import React, { useEffect, useState, useRef } from 'react';
import "./userprofile.css";
import { useDispatch, useSelector } from 'react-redux';
import { clearMessage, userProfileUpdateRequest, generateOtp, varifyOtp } from '../../actions/userActions';
import ImageCropModal from '../common/ImageCropModel';
import { fetchUserDataRequest } from '../../actions/dashboardActions';
import profileImage from "../../assets/profiledefaultimg.webp";
import GetfirstAndLastName from '../common/GetfirstAndLastName';
import { fetchTeacherCreatedTests } from '../../actions/testActions';
import { formatDateForBackend, formatDateForInput } from '../common/DateFormats';
import { FaSpinner } from 'react-icons/fa';
import { Spinner } from 'react-bootstrap';

function CreatorProfile() {
    const teacherProfileData = useSelector(state => state.dashboard.userData);
    const fetchinguserdata = useSelector(state => state.dashboard.fetchinguserdata);
    const teacherCreatedTests = useSelector(state => state.tests.teacherCreatedTest);
    const studentResultsForTeacher = useSelector(state => state.tests.teacherCreatedTest);

    // OTP related state
    const [otp, setOtp] = useState(['', '', '', '']);
    const [isEmailEditing, setIsEmailEditing] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [otpResendTimer, setOtpResendTimer] = useState(0);
    const [isEmailChanged, setIsEmailChanged] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    // const [showPassword, setShowPassword] = useState(false);

    const inputRefs = useRef([]);
    const resendTimerRef = useRef(null);

    const [isEditing, setIsEditing] = useState(false);
    const [errors, setErrors] = useState({});
    const [showCropModal, setShowCropModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [imgloading, setImgLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: '', type: '' });

    const updateprofileSucess = useSelector(state => state.user.updateprofileSucess);
    const otpGenerated = useSelector(state => state.user.otpGenerated);
    const otpSuccess = useSelector(state => state.user.otpSuccess);
    const verifiedOtp = useSelector(state => state.user.varifiedOtp);
    const message = useSelector(state => state.user.message);

    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        name: teacherProfileData.name || "",
        email: teacherProfileData.email || "",
        dateOfBirth: teacherProfileData.dateOfBirth || "",
        gender: teacherProfileData.gender || "",
        mobileNumber: teacherProfileData.mobileNumber || "",
        // password: teacherProfileData.password || "",
        address: teacherProfileData.address || "",
        role: teacherProfileData.role,
        id: teacherProfileData._id
    });

    // Count pass/fail students
    function countPassFailStudents(results) {
        let passCount = 0;
        let failCount = 0;

        results.forEach(student => {
            student.submitedBy.forEach(status => {
                if (status.passStatus === "Pass") {
                    passCount++;
                } else if (status.passStatus === "Fail") {
                    failCount++;
                }
            });
        });

        return { passCount, failCount };
    }

    const { passCount, failCount } = countPassFailStudents(studentResultsForTeacher);

    useEffect(() => {
        if (!teacherProfileData || !teacherCreatedTests.length || !studentResultsForTeacher.length) {
            if (!teacherProfileData) {
                dispatch(fetchUserDataRequest());
            }
            if (!teacherCreatedTests.length) {
                dispatch(fetchTeacherCreatedTests());
            }
        }
    }, []);

    useEffect(() => {
        if (updateprofileSucess) {
            dispatch(fetchUserDataRequest());
            showNotification("Profile updated successfully! 🎉", "success");
            setLoading(false);
            setTimeout(() => {
                setImgLoading(false);
                dispatch(clearMessage());
            }, 2000);
            if (isEmailChanged) {
                setIsEmailEditing(false);
                setOtpVerified(false);
                setIsEmailChanged(false);
                setOtp(['', '', '', '']);
                setOtpResendTimer(0);
                clearInterval(resendTimerRef.current);
            }
        }
    }, [updateprofileSucess, dispatch, isEmailChanged]);

    useEffect(() => {
        setFormData({
            name: teacherProfileData.name || "",
            email: teacherProfileData.email || "",
            dateOfBirth: teacherProfileData.dateOfBirth
                ? formatDateForInput(teacherProfileData.dateOfBirth)
                : "",
            gender: teacherProfileData.gender || "",
            mobileNumber: teacherProfileData.mobileNumber || "",
            // password: teacherProfileData.password || "",
            address: teacherProfileData.address || "",
            role: teacherProfileData.role,
            id: teacherProfileData._id
        });
    }, [teacherProfileData]);

    const handleOtpChange = (index, value) => {
        if (/[^0-9]/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 3) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const startResendTimer = () => {
        setOtpResendTimer(120);
        resendTimerRef.current = setInterval(() => {
            setOtpResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(resendTimerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleSendOTP = () => {
        if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            showNotification("Please enter a valid email address", "error");
            return;
        }

        if (otpResendTimer > 0) return;

        dispatch(generateOtp({
            email: formData.email,
            isStudent: false, // Changed to false for creator
            newuser: false
        }));
        startResendTimer();
    };

    const handleVerifyOTP = () => {
        if (otp.some(value => value === '')) {
            showNotification("Please enter the complete OTP", "error");
            return;
        }

        setIsVerifying(true);
        dispatch(varifyOtp({
            email: formData.email,
            otp: otp.join('')
        }));
    };

    const showNotification = (message, type) => {
        setNotification({ show: true, message, type });
        setTimeout(() => {
            setNotification({ show: false, message: '', type: '' });
        }, 3000);
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });

        if (name === "email" && value !== teacherProfileData.email) {
            setIsEmailChanged(true);
            setOtpVerified(false);
        }
    };

    const handleSaveChanges = (e) => {
        e.preventDefault();
        setLoading(true);

        if (isEmailChanged && !otpVerified) {
            showNotification("Please verify your new email with OTP before saving", "error");
            setLoading(false);
            return;
        }

        const dataToSend = {
            ...formData,
            dateOfBirth: formData.dateOfBirth
                ? formatDateForBackend(formData.dateOfBirth)
                : null
        };

        if (validateForm()) {
            dispatch(userProfileUpdateRequest(dataToSend));
            setIsEditing(false);
        } else {
            setLoading(false);
        }
    };

    const validateForm = () => {
        let errors = {};
        let isValid = true;

        if (!formData.name.trim()) {
            errors.name = 'Name is required';
            isValid = false;
        }

        if (!formData.email.trim()) {
            errors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Email is invalid';
            isValid = false;
        }

        if (!String(formData.mobileNumber).trim()) {
            errors.mobileNumber = 'Mobile number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
            errors.mobileNumber = 'Mobile number must be 10 digits';
            isValid = false;
        }

        // Add validation for date of birth
        if (!formData.dateOfBirth) {
            errors.dateOfBirth = 'Date of birth is required';
            isValid = false;
        }
        setErrors(errors);
        return isValid;
    };

    useEffect(() => {
        if (otpGenerated) {
            if (otpSuccess === "key generated") {
                showNotification("OTP has been sent to your email", "success");
                setIsEmailEditing(true);
            } else if (otpSuccess === "Email Dosen't Exist in the database") {
                showNotification("This email is not registered with us", "error");
                setOtpResendTimer(0);
                clearInterval(resendTimerRef.current);
            }
        }
        dispatch(clearMessage());
    }, [otpGenerated, otpSuccess, dispatch]);

    useEffect(() => {
        if (verifiedOtp) {
            setIsVerifying(false);
            if (message === "otp varified") {
                showNotification("Your OTP has been verified successfully", "success");
                setOtpVerified(true);
            } else if (message === "otp not varified") {
                showNotification("The OTP you entered is incorrect", "error");
            }
        }
        dispatch(clearMessage());
    }, [verifiedOtp, message, dispatch]);

    const [image, setImage] = useState();

    const handleImageChange = e => {
        if (e.target.files && e.target.files[0]) {
            setImage(e.target.files[0]);
            setShowCropModal(true);
        }
    };

    const handleImageUpload = (croppedImage) => {
        if (croppedImage) {
            setImgLoading(true);
            const newFormdata = {
                ...formData,
                image: croppedImage
            };
            dispatch(userProfileUpdateRequest(newFormdata));
        }
    };

    if (fetchinguserdata) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh', color: '#0096c7' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <>
            {notification.show && (
                <div className={`profile-notification profile-notification-${notification.type}`}>
                    {notification.message}
                </div>
            )}

            <div className="profile-container container-fluid">
                <h1>Creator Profile</h1>
                <div className="profile-main-body">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="profile-card">
                                <div className="profile-card-body">
                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Full Name</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <input
                                                type="text"
                                                name="name"
                                                className={`profile-form-control ${errors.name ? 'profile-is-invalid' : ''}`}
                                                onChange={handleChange}
                                                value={formData.name}
                                                disabled={!isEditing}
                                            />
                                            {errors.name && <div className="profile-invalid-feedback">{errors.name}</div>}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Email</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <div className="profile-email-verification-container">
                                                <input
                                                    type="text"
                                                    className={`profile-form-control ${errors.email ? 'profile-is-invalid' : ''}`}
                                                    name="email"
                                                    onChange={handleChange}
                                                    value={formData.email}
                                                    // disabled={!isEditing || (isEmailEditing && otpVerified)}
                                                    disabled={true}
                                                />
                                                {isEditing && formData.email !== teacherProfileData.email && !otpVerified && (
                                                    <button
                                                        type="button"
                                                        className="profile-otp-btn"
                                                        onClick={handleSendOTP}
                                                        disabled={otpResendTimer > 0}
                                                    >
                                                        {otpResendTimer > 0 ? `${otpResendTimer}s` : "Send OTP"}
                                                    </button>
                                                )}
                                                {otpVerified && (
                                                    <span className="profile-verified-badge">Verified</span>
                                                )}
                                            </div>
                                            {errors.email && <div className="profile-invalid-feedback">{errors.email}</div>}

                                            {isEmailEditing && !otpVerified && (
                                                <div className="profile-otp-verification-section mt-3">
                                                    <p className="profile-otp-instruction">Enter the OTP sent to your email</p>
                                                    <div className="profile-otp-input-group">
                                                        {[0, 1, 2, 3].map((index) => (
                                                            <input
                                                                key={index}
                                                                ref={el => inputRefs.current[index] = el}
                                                                type="text"
                                                                value={otp[index]}
                                                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                                                onKeyDown={(e) => handleKeyDown(index, e)}
                                                                maxLength="1"
                                                                className="profile-otp-input"
                                                                disabled={otpVerified}
                                                            />
                                                        ))}
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="profile-verify-otp-btn"
                                                        onClick={handleVerifyOTP}
                                                        disabled={otp.some(value => value === '') || isVerifying}
                                                    >
                                                        {isVerifying ? (
                                                            <>
                                                                <FaSpinner className="profile-spin me-2" />
                                                                Verifying...
                                                            </>
                                                        ) : (
                                                            "Verify OTP"
                                                        )}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Date of Birth</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <input
                                                type="date"
                                                name='dateOfBirth'
                                                className="form-control"
                                                onChange={handleChange}
                                                value={formatDateForInput(formData.dateOfBirth)}
                                                disabled={!isEditing}
                                            />
                                            {errors.dateOfBirth && <div className="profile-invalid-feedback">{errors.dateOfBirth}</div>}

                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Gender</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <select
                                                className="form-select"
                                                name="gender"
                                                onChange={handleChange}
                                                value={formData.gender}
                                                disabled={!isEditing}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">Other</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Mobile Number</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <input
                                                type="number"
                                                onChange={handleChange}
                                                name='mobileNumber'
                                                className={`form-control ${errors.mobileNumber ? 'is-invalid' : ''}`}
                                                value={formData.mobileNumber}
                                                disabled={!isEditing}
                                            />
                                            {errors.mobileNumber && <div className="invalid-feedback">{errors.mobileNumber}</div>}
                                        </div>
                                    </div>

                                    {/* <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Password</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <div className="password-input-container">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className={`profile-form-control ${errors.password ? 'profile-is-invalid' : ''}`}
                                                    name='password'
                                                    onChange={handleChange}
                                                    value={formData.password}
                                                    disabled={!isEditing}
                                                />
                                                <button
                                                    type="button"
                                                    className="password-toggle-btn"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </button>
                                            </div>
                                            {errors.password && <div className="profile-invalid-feedback">{errors.password}</div>}
                                        </div>
                                    </div> */}

                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6 className="mb-0">Address</h6>
                                        </div>
                                        <div className="col-sm-9 text-secondary">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name='address'
                                                onChange={handleChange}
                                                value={formData.address}
                                                disabled={!isEditing}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-3"></div>
                                        <div className="col-sm-9 text-secondary">
                                            {loading ? (
                                                <button className="btn profile-button-design px-4" disabled>
                                                    <span className="profile-spinner-border profile-spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Saving...
                                                </button>
                                            ) : (
                                                <>
                                                    {isEditing ? (
                                                        <>
                                                            <button className="btn profile-button-design px-4 me-2 m-1" onClick={handleSaveChanges}>
                                                                Save Changes
                                                            </button>
                                                            <button className="btn btn-secondary px-4 m-1" onClick={() => {
                                                                setIsEditing(false);
                                                                setIsEmailEditing(false);
                                                                setOtpVerified(false);
                                                                setOtp(['', '', '', '']);
                                                            }}>
                                                                Cancel
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <button className="btn profile-button-design px-4" onClick={() => setIsEditing(true)}>
                                                            Edit Profile
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="profile-card">
                                <div className="profile-card-body">
                                    <div className="d-flex flex-column align-items-center text-center">
                                        {imgloading ? (
                                            <div className="profile-image-loading">
                                                <img
                                                    src={teacherProfileData.imagepath || profileImage}
                                                    alt="Profile"
                                                    className="profile-rounded-circle profile-p-1 profile-bg-primary"
                                                />
                                                <div className="profile-spinner-overlay">
                                                    <div className="profile-spinner-border profile-text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="profile-image-container">
                                                <img
                                                    src={teacherProfileData.imagepath || profileImage}
                                                    alt="Profile"
                                                    className="profile-rounded-circle profile-p-1"
                                                    style={{ backgroundColor: "#0096c7" }}
                                                />
                                                <button
                                                    className="profile-edit-image-btn"
                                                    onClick={() => document.getElementById('fileInput').click()}
                                                    title="Change profile picture"
                                                >
                                                    ✏️
                                                </button>
                                                <input
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    id="fileInput"
                                                />
                                            </div>
                                        )}
                                        <div className="mt-3">
                                            <h4>{GetfirstAndLastName(teacherProfileData.name)}</h4>
                                            <p className="text-secondary mb-1">{teacherProfileData.role}</p>
                                        </div>
                                    </div>

                                    <hr className="my-4" />
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                            <h6 className="mb-0 d-flex align-items-center">
                                                <span className="profile-emoji-icon">👥</span>
                                                Subscribers
                                            </h6>
                                            <span className="text-secondary">{teacherProfileData.subscribers?.length || 0}</span>
                                        </li>

                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                            <h6 className="mb-0 d-flex align-items-center">
                                                <span className="profile-emoji-icon">📝</span>
                                                Tests Created
                                            </h6>
                                            <span className="text-secondary">{teacherCreatedTests.length}</span>
                                        </li>

                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                            <h6 className="mb-0 d-flex align-items-center">
                                                <span className="profile-emoji-icon">🏆</span>
                                                Students Passed
                                            </h6>
                                            <span className="text-secondary">{passCount}</span>
                                        </li>

                                        <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                            <h6 className="mb-0 d-flex align-items-center">
                                                <span className="profile-emoji-icon">😞</span>
                                                Students Failed
                                            </h6>
                                            <span className="text-secondary">{failCount}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ImageCropModal
                show={showCropModal}
                onHide={() => setShowCropModal(false)}
                image={image}
                handleImageUpload={handleImageUpload}
            />
        </>
    );
}

export default CreatorProfile;